import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  field: FelaCSS;
}

const styles: IStyles = {
  field: {
    paddingBottom: spacing[4],
    gap: spacing[1],
  },
};

export default styles;
